const instagramErrors = new Map([
	[
		9007,
		"Instagram Profile $userName post has failed due to technical issue. Kindly republish the post.",
	],
	[
		-2,
		"Instagram Profile $userName post has failed due to technical issue. Kindly republish the post.",
	],
	[
		-1,
		"Instagram Profile $userName post has failed due to technical issue. Kindly republish the post.",
	],
	[
		9,
		"Instagram Profile $userName post has failed due to technical issue. Kindly republish the post.",
	],
	[
		24,
		"Instagram Profile $userName post has failed due to technical issue. Kindly republish the post.",
	],
	[
		9004,
		"Instagram Profile $userName post has failed due to technical issue. Kindly republish the post.",
	],
	[
		36001,
		"Instagram Profile $userName post has failed due to technical issue. Kindly republish the post.",
	],
	[
		1,
		"Instagram Profile $userName post has failed due to technical issue. Kindly republish the post.",
	],
	[
		2,
		"Instagram Profile $userName post has failed due to technical issue. Kindly republish the post.",
	],
	[
		17,
		"Instagram Profile $userName post has failed due to technical issue. Kindly republish the post.",
	],
	[
		341,
		"Instagram Profile $userName post has failed due to technical issue. Kindly republish the post.",
	],
	[
		368,
		"Instagram Profile $userName post has failed due to technical issue. Kindly republish the post.",
	],
	[
		1609005,
		"Instagram Profile $userName post has failed due to technical issue. Kindly republish the post.",
	],
	[
		4,
		"The instagram Profile $userName post has failed as the content has been flagged as spam.",
	],

	[25, "$errorMessage"],
	[506, "$errorMessage"],
	[459, "$errorMessage"],
	[460, "$errorMessage"],
	[464, "$errorMessage"],
	[492, "$errorMessage"],
	[352, "$errorMessage"],

	[
		102,
		"Instagram Profile $userName access token has expired. Kindly reconnect the profile in settings",
	],
	[
		190,
		"Instagram Profile $userName access token has expired. Kindly reconnect the profile in settings",
	],
	[
		463,
		"Instagram Profile $userName access token has expired. Kindly reconnect the profile in settings",
	],
	[
		458,
		"Instagram Profile $userName access token has expired. Kindly reconnect the profile in settings",
	],

	[
		467,
		"Instagram Profile $userName access token is invalid. Kindly reconnect the profile in settings",
	],

	[
		3,
		"Instagram Profile $userName does not have the required permission. Kindly reconnect the profile in settings and provide the necessary permissions",
	],
	[
		10,
		"Instagram Profile $userName does not have the required permission. Kindly reconnect the profile in settings and provide the necessary permissions",
	],
	[
		200,
		"Instagram Profile $userName does not have the required permission. Kindly reconnect the profile in settings and provide the necessary permissions",
	],
]);

export const getInstagramError = (instagramError) => {
	let errorMessage = "";
	const error = instagramError.error;
	const userName = instagramError.instagram_username;

	if (error.code >= 200 && error.code <= 299) {
		errorMessage = instagramErrors.get(200);
	} else {
		errorMessage = instagramErrors.get(error.code);
	}

	if (!errorMessage) {
		errorMessage = instagramErrors.get(error.error_subcode);
	}

	if (!errorMessage) {
		errorMessage = error.error_user_msg ? error.error_user_msg : error.message;
	}

	if (errorMessage.includes("$errorMessage")) {
		errorMessage = errorMessage.replace("$errorMessage", errorMessage);
	}

	if (errorMessage.includes("$userName")) {
		errorMessage = errorMessage.replace("$userName", userName);
	}

	return errorMessage;
};
